export const cities = () => 'FNOLSifarnici/GetNaselja';
export const policyDetails = () => 'FNOLPPI/GetDetaljiPolise';
export const roles = () => 'FNOLSifarnici/GetPPISvojstvoUcesnika';
export const risks = () => 'FNOLSifarnici/GetPPIRizike';
export const documents = (id: string) => `FNOL/GetDokumentaZaUpload?stetaTempId=${id}`;
export const addDocuments = () => 'FNOL/UploadDokumentacije';
export const claimSubmit = () => 'FNOLPPI/OnlinePrijavaStete';
export const claimConfirmation = () => 'FNOL/PotvrdaPrijaveStete';
export const claimConfirmationAnonymous = () => 'FNOL/PotvrdaPrijaveSteteAnonimni';
